import { render, staticRenderFns } from "./FAQImageContainer.vue?vue&type=template&id=0073abe6&scoped=true&"
import script from "./FAQImageContainer.vue?vue&type=script&lang=js&"
export * from "./FAQImageContainer.vue?vue&type=script&lang=js&"
import style0 from "./FAQImageContainer.vue?vue&type=style&index=0&id=0073abe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0073abe6",
  null
  
)

export default component.exports